import { translate } from '@vimeo/i18n-runtime';

import styles from './PlaylistHeader.module.scss';
import PlaylistThumbnailGrid from './PlaylistThumbnailGrid';

// Values sourced from ~/objects/Clip.php
const PRIVACY_NOBODY = 'nobody';
const PRIVACY_FOLLOW = 'contacts';
const PRIVACY_PASSWORD = 'password';

const privacyOptions = {
  [PRIVACY_NOBODY]: translate('Private'),
  [PRIVACY_FOLLOW]: translate('Only people I follow'),
  [PRIVACY_PASSWORD]: translate('Only people with a password'),
};

const PlaylistHeader = ({
  clips,
  headerRef,
  isMobile,
  privacy,
  title,
  tracklistExpanded,
  user,
}) => {
  const images = clips.map((clip) => clip.thumbnail);

  const fromUsername = translate({
    singular: 'from {USERNAME}',

    replacements: {
      USERNAME: user,
    },
  });

  const tooltipText = privacy ? privacyOptions[privacy] : null;

  return (
    <div className={styles.playlistHeader} ref={headerRef}>
      {isMobile && tracklistExpanded ? null : (
        <PlaylistThumbnailGrid isMobile={isMobile} images={images} />
      )}
      <div className={styles.playlistHeaderDetails}>
        <div className={styles.playlistHeaderTitle}>
          {privacy && (
            <span
              className={`${styles.playlistTooltip} ${styles.playlistHeaderLockIcon}`}
              data-tooltip-text={tooltipText}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                <path d="M16 8h-1V5A5 5 0 0 0 5 5v3H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM7 5a3 3 0 0 1 6 0v3H7z" />
              </svg>
            </span>
          )}
          <span>{title}</span>
        </div>
        {(!isMobile || tracklistExpanded) && (
          <p className={styles.playlistHeaderUser}>{fromUsername}</p>
        )}
      </div>
    </div>
  );
};

export default PlaylistHeader;
